<template>
  <div>
    <el-dialog
      v-model="visible"
      :title="t('designer.jsonView.title')"
      width="50%"
      :close-on-click-modal="false"
    >
      <template #header>
        <el-space>
          <div style="margin-right: 20px">{{ t('designer.jsonView.title') }}</div>
          <el-switch
            v-model="tidMode"
            :active-text="t('designer.jsonView.tidMode')"
            :inactive-text="t('designer.jsonView.defaultMode')"
            @change="onModeChange"
          />
          <el-switch
            v-model="beautify"
            :active-text="t('designer.jsonView.beautify')"
            :inactive-text="t('designer.jsonView.compress')"
            @change="onModeChange"
          />
        </el-space>
      </template>
      <el-input
        disabled
        v-loading="spinning"
        type="textarea"
        style="width: 100%; height: 100%; min-height: 400px"
        v-model="jsonOut"
        class="json-view-textarea"
        :rows="20"
      />
      <template #footer>
        <el-button @click="hideModal"> {{ t('designer.jsonView.close') }} </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue'
import { ElMessage } from 'element-plus'
import { useErpI18n } from '@/composables/useErpI18n'

// 使用多语言
const { t } = useErpI18n()

// 定义 hiprint 模板类型
interface PrintInstance {
  getJson(): any
  getJsonTid(): any
}

// 定义 props
interface Props {
  template?: PrintInstance
}

const props = withDefaults(defineProps<Props>(), {
  template: undefined,
})

// 响应式状态
const visible = ref<boolean>(false)
const spinning = ref<boolean>(true)
const jsonOut = ref<string>('')
const tidMode = ref<boolean>(false)
const beautify = ref<boolean>(false)

/**
 * 隐藏模态框
 */
const hideModal = (): void => {
  visible.value = false
}

/**
 * 显示 JSON 视图
 */
const show = (): void => {
  try {
    console.log('props.template', props.template)
    if (!props.template) {
      ElMessage.error(t('designer.jsonView.noTemplate'))
      return
    }

    visible.value = true
    spinning.value = true

    nextTick(() => {
      try {
        const json = tidMode.value ? props.template!.getJsonTid() : props.template!.getJson()

        const beautifySpacing = beautify.value ? 2 : 0
        jsonOut.value = JSON.stringify(json, null, beautifySpacing)
      } catch (error) {
        console.error('获取JSON失败:', error)
        ElMessage.error(t('designer.jsonView.getJsonFailed'))
        jsonOut.value = t('designer.jsonView.getJsonFailed')
      } finally {
        spinning.value = false
      }
    })
  } catch (error) {
    console.error('显示JSON视图失败:', error)
    ElMessage.error(t('designer.jsonView.showJsonFailed'))
    spinning.value = false
  }
}

/**
 * 模式变化处理
 */
const onModeChange = (): void => {
  show()
}

// 暴露组件方法供父组件调用
defineExpose({
  show,
})
</script>
<style lang="scss" scoped>
:deep(.el-dialog__body) {
  padding: 20px;
  overflow-y: auto;
  max-height: calc(80vh - 120px); // 减去头部和底部的高度
  .json-view-textarea {
    .el-textarea__inner {
      font-size: 12px;
      height: 100%;
      background-color: transparent !important;
      color: #303133;
    }
  }
}

:deep(.el-dialog) {
  margin-bottom: 24px;
  max-height: 80vh;
  overflow: hidden;
}

:deep(.el-dialog__header) {
  flex-shrink: 0;
}

:deep(.el-dialog__footer) {
  flex-shrink: 0;
}
</style>
